module.exports = __webpack_public_path__ + "img/image (1).98480eed.png";